import { createSlice } from '@reduxjs/toolkit';

export const infoSlice = createSlice({
  name: 'info',
  initialState: {
    role: '',
    location: null,
    frequency: null,
    scores: new Array(17).fill(0)
  },
  reducers: {
    setRole: (state, action) => {
      state.role = action.payload;
    },
    setLocation: (state, action) => {
      state.location = action.payload;
    },
    setFrequency: (state, action) => {
      state.frequency = action.payload;
    },
    setScore: (state, action) => {
      const { pageIndex, score } = action.payload;
      state.scores[pageIndex] = score;
    },
  },
})

export const { setRole, setLocation, setFrequency, setScore } = infoSlice.actions

export const selectRole = (state) => state.info.role
export const selectLocation = (state) => state.info.location
export const selectFrequency = (state) => state.info.frequency
export const selectScores = (state) => state.info.scores


export default infoSlice.reducer
